<template>
    <div class="aaHostView m-agency" v-if="init">
        <div class="m-header" :style="'background:url('+imgAgency+');background-repeat:no-repeat;background-size:100% 100%;'">
            <div class="top">
                <div class="agency-logo">
                    <img class="img" v-lazy="item.hostpic" alt="" />
                    <span class="blod text-ellipses hostname">{{item.hostname}}</span>
                    <span class="follow" @click="handleFollow">{{item.isfavorite==1?'已关注': '+ 关注'}}</span>
                </div>
            </div>
            <div class="bottom">
                <div class="box">
                    <div class="name">活动数</div>
                    <div class="value">{{item.eventcount}}</div>
                </div>
                <div class="box">
                    <div class="name">粉丝数</div>
                    <div class="value">{{item.favoritecount}}</div>
                </div>
            </div>
        </div>
        <div class="m-body">
            <vActivityList ref="vActivityList"></vActivityList>
        </div>
        <div class="serve icon-aa-wachet" @click="openService" v-if="item.mpqrcode"></div>
        <Popup :pop="service" ref="service">
        </Popup>
    </div>
</template>

<script>
  import {getHostDetail, operateHostFollowInfo} from 'api/activeTools'
  import {mapActions, mapGetters} from 'vuex'
  import Popup from 'views/mobile/components/popup/popup'
  // import {promiseUrlToQRCode} from 'common/js/tools'
  import VActivityList from 'views/mapply/components/vActivityList.vue'
  export default {
    name: 'aaHostView',
    data() {
      return {
        imgAgency: require('@/common/images/activeTools/img-host.png'),
        param: {
          hostid: this.$route.query.hostid ? this.$route.query.hostid : ''
        },
        item: {
          eventcount: 0,
          favoritecount: 0,
          hostdesp: '',
          hostid: '',
          hostname: '',
          hostpic: '',
          isfavorite: 0,
          mpname: '',
          mpqrcode: ''
        },
        service: {
          url: '',
          title: '',
          tip: [],
          isSave: false
        },
        init: false
      }
    },
    mounted() {
      document.title = '主办方'
      document.documentElement.scrollTop = document.body.scrollTop = 0
      if (!this.refresh) {
        this.getView()
      }
    },
    activated() {
      if (this.refresh) {
        this.init = false
        document.documentElement.scrollTop = document.body.scrollTop = 0
        this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
        this.getView()
        this.setRefresh(false)
      }
    },
    methods: {
      handleFollow() {
        if (this.user.isLogin) {
          let param = {
            hostid: this.item.hostid,
            optype: this.item.isfavorite == 1 ? 2 : 1, // 操作类型 1关注 2取消关注
          }
          if (param.optype == 2) {
            this.$dialog.confirm({
              title: '提示',
              message: '确定取消关注？'
            }).then(() => {
              this._setFollow(param)
            }).catch(() => {})
          } else {
            this._setFollow(param)
          }
        } else {
          this.$toast.fail('请先登录')
          this.$router.push({name: 'MLogin'})
        }
      },
      openService() {
        this.$refs.service.open()
      },
      _setFollow(param) {
        this.setLoading(true)
        operateHostFollowInfo({
          data: param,
          success: () => {
            this.item.isfavorite = param.optype == 2 ? 0 : 1
            this.$toast.success('操作成功')
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getView() {
        this.setLoading(true)
        getHostDetail({
          data: this.param,
          success: data => {
            this.item = data.data
            document.title = this.item.hostname
            this.init = true
            this.service.url = this.item.mpqrcode
            this.service.tip = [this.item.hostname, '关注微信公众号了解更多']
            this.$nextTick(() => {
              this.$refs.vActivityList.initList()
            })
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['refresh', 'user'])
    },
    components: {
      Popup, VActivityList
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~views/mobile/sort/agency/agency";
    .aaHostView {
        background: #fff;
        .agency-logo{
            width: 100%;
            .hostname{
                flex-grow: 1;
            }
            .follow{
                width: 1.22rem;
                height: 0.45rem;
                line-height: 0.46rem;
                text-align: center;
                border-radius: 0.23rem;
                border: 0.01rem solid #fff;
                font-size: 0.26rem;
                background:rgba(255,255,255,0.3)
            }
        }
        .bottom{
            background:rgba(0,0,0,0.2) !important;
            margin-top: 0.2rem;
            height: 1rem !important;
        }
        .m-body{
            .title{
                padding: 0.32rem 0.32rem 0.16rem 0.32rem;
                color: $c-black;
                font-size: 0.28rem;
                font-weight: 600;
                background: $c-white;
            }
        }
        .noData{
             /*height: calc(100vh - 4.1rem);*/
             height: calc(100vh - 0.8rem);
             background: $c-white;
             .tip{
                 margin-bottom: 4rem;
             }
         }
        .noData+.van-list__finished-text{
            display: none;
        }
        .service-popup .serviceCode .codeBox .code{
            width: 3.6rem !important;
            height: 3.6rem !important;
        }
    }
</style>